import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#020202] border-t border-white/10 mt-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-heading font-black text-3xl tracking-tighter text-white">
            E·QUANTUM
            <span className="text-[var(--primary)]">.</span>
          </div>
          <p className="mt-4 text-zinc-400 text-sm leading-relaxed max-w-md">
            We exist for one reason — to put the power, the rights, and the
            money back in the hands of the artist.
          </p>
          <div className="flex items-center gap-3 mt-8">
            <a href="#" className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-[var(--primary)] hover:text-[var(--primary)] transition-colors text-zinc-400">
              <Instagram size={16} />
            </a>
            <a href="#" className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-[var(--primary)] hover:text-[var(--primary)] transition-colors text-zinc-400">
              <Twitter size={16} />
            </a>
            <a href="#" className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-[var(--primary)] hover:text-[var(--primary)] transition-colors text-zinc-400">
              <Youtube size={16} />
            </a>
            <a href="mailto:hello@equantum.com" className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-[var(--primary)] hover:text-[var(--primary)] transition-colors text-zinc-400">
              <Mail size={16} />
            </a>
          </div>
        </div>

        <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--primary)] mb-4">
              Services
            </div>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link to="/services" className="hover:text-white">Publishing</Link></li>
              <li><Link to="/services" className="hover:text-white">Royalty Collection</Link></li>
              <li><Link to="/services" className="hover:text-white">Placements</Link></li>
              <li><Link to="/services" className="hover:text-white">Career Consulting</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--primary)] mb-4">
              Company
            </div>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
              <li><Link to="/booking" className="hover:text-white">Book a call</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--primary)] mb-4">
              Artist Portal
            </div>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link to="/login" className="hover:text-white">Sign in</Link></li>
              <li><Link to="/register" className="hover:text-white">Create account</Link></li>
              <li><Link to="/dashboard" className="hover:text-white">Dashboard</Link></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} E-Quantum Consults. All rights reserved.</div>
          <div className="font-mono tracking-widest">PUBLISHING · ROYALTIES · PLACEMENT · MARKETING</div>
        </div>
      </div>
    </footer>
  );
}
